import React, { useState } from 'react';

import { Tabs } from 'antd';

import ApiDocsPanel from './ApiDocsPanel';
import ApiKeysPanel from './ApiKeysPanel';
import ApiSubscriptionPanel from './ApiSubscriptionPanel';

const { TabPane } = Tabs;

const ApiTab: React.FC = () => {
    const [inner, setInner] = useState<string>('subscription');

    return (
        <Tabs activeKey={inner} onChange={setInner} type="card">
            <TabPane tab="Подписка" key="subscription">
                <ApiSubscriptionPanel />
            </TabPane>
            <TabPane tab="API-ключи" key="keys">
                <ApiKeysPanel />
            </TabPane>
            <TabPane tab="Документация" key="docs">
                <ApiDocsPanel />
            </TabPane>
        </Tabs>
    );
};

export default ApiTab;
